import { Component, OnInit, inject } from '@angular/core';
import { ClientEspNdcImport } from 'app/core/models/client-esp-ndc-import.model';
import { LimitOffsetPaging } from 'app/core/models/paged-results/limit-offset-paging.model';
import { ClientEspNdcImportFilters } from 'app/core/models/user-settings/client-esp-ndc-import-settings.model';
import { ClientEspNdcImportsService } from 'app/core/services/client-esp-ndc-imports.service';
import { DownloadService } from 'app/core/services/download.service';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { FormsModule } from '@angular/forms';
import { TitleCasePipe, DatePipe } from '@angular/common';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ClientSelectComponent } from '../../../shared/components/client-select/client-select.component';


@Component({
    selector: 'app-capture-admin-import-client-esp-ndcs-history',
    templateUrl: './capture-admin-import-client-esp-ndcs-history.component.html',
    styleUrls: ['./capture-admin-import-client-esp-ndcs-history.component.scss'],
    imports: [
    ImportNavComponent,
    FormsModule,
    ClientSelectComponent,
    PaginationHeaderComponent,
    FaIconComponent,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    PaginationComponent,
    MatProgressSpinner,
    TitleCasePipe,
    DatePipe
],
})
export class CaptureAdminImportClientEspNdcsHistoryComponent implements OnInit {
  private downloadService = inject(DownloadService);
  private clientEspNdcImportsService = inject(ClientEspNdcImportsService);

  loading = false;
  clientEspNdcImports: ClientEspNdcImport[] = [];
  clientFilterOptions = [];
  paging: LimitOffsetPaging;
  nextCheckTimeout = null;
  filters: ClientEspNdcImportFilters = new ClientEspNdcImportFilters();

  ngOnInit() {
    this.paging = LimitOffsetPaging.empty;
    this.paging.currentPage = 1;
    this.loadImports(this.paging.currentPage);
  }

  onPageSizeChange(size: number) {
    this.paging.pageSize = size;
    this.loadImports(this.paging.currentPage);
  }

  onPageChange(page: number) {
    this.loadImports(page);
  }

  private loadImports(page, loading = true) {
    this.loading = loading;
    const paging = { page, pageSize: this.paging.pageSize };
    this.clientEspNdcImportsService.getList(paging, this.filters).subscribe(result => {
      this.clientEspNdcImports = result.clientEspNdcImports;
      this.paging = result.meta.paging;
      this.loading = false;

      const anyActive: boolean = this.clientEspNdcImports.some(clientEspNdcImport => clientEspNdcImport.active);

      if (anyActive) {
        this.nextCheckTimeout = setTimeout(() => this.loadImports(this.paging.currentPage, false), 5000);
      }
    });
  }

  onCancelClick($event, clientEspNdcImport: ClientEspNdcImport) {
    $event.preventDefault();
    this.clientEspNdcImportsService.cancel(clientEspNdcImport.id).subscribe(data => {
      const index = this.clientEspNdcImports.findIndex(imp => imp.id === data.id);

      if (index > -1) {
        this.clientEspNdcImports[index] = data;
        this.clientEspNdcImports = [...this.clientEspNdcImports];
      }
    });
  }

  onFilterChange() {
    this.loadImports(this.paging.currentPage);
  }

  onDownloadFileClick($event, clientEspNdcImport: ClientEspNdcImport) {
    $event.preventDefault();
    this.clientEspNdcImportsService.get(clientEspNdcImport.id).subscribe(ci => {
      this.downloadService.getDownloadUrl(ci.fileExpirableDownloadPath).subscribe(expirableDownload => {
        this.downloadService.download(expirableDownload.url);
      });
    });
  }

  onDownloadSkippedClick($event, clientEspNdcImport: ClientEspNdcImport) {
    $event.preventDefault();
    this.clientEspNdcImportsService.get(clientEspNdcImport.id).subscribe(ci => {
      this.downloadService.getDownloadUrl(ci.skippedFileExpirableDownloadPath).subscribe(expirableDownload => {
        this.downloadService.download(expirableDownload.url);
      });
    });
  }
}
